import { html, View } from 'rune-ts';
import klass from './NessBadge.module.scss';

export class SpecialOfferBadge extends View<{
  klass?: string;
}> {
  override template() {
    return html`<span class="${klass.badge} ${klass.special_offer} ${this.data.klass ?? ''}">
      ${ET('ness::product::product_06')}
    </span>`;
  }
}
